<template>
  <div class="situation-container container">
    <span class="basic-title">急救车出车情况：</span>
    <div class="ambulance-info">
      <el-row class="info-row">
        <el-col class="info-key" :span="2" :offset="0">
          急救车编号：
        </el-col>
        <el-col class="info-item" :span="3" :offset="0">
          {{ ambulance?.name }}({{ ambulance?.idName }})
        </el-col>
        <el-col class="info-key" :span="2" :offset="0">
          事件类型：
        </el-col>
        <el-col class="info-item" :span="3" :offset="0">
          {{ patient.type }}
        </el-col>
        <el-col class="info-key" :span="2" :offset="0">
          总用时：
        </el-col>
        <el-col v-if="patient.costTime" class="info-item" :span="3" :offset="0">
          {{ Math.round(patient.costTime / 60) }}
          <span v-if="patient.costTime">分钟</span>
        </el-col>
        <el-col class="info-key" :span="2" :offset="1">
          目的地：
        </el-col>
        <el-col class="info-item" :span="6" :offset="0">
          {{ patient.patientAddr }}
        </el-col>
      </el-row>
      <el-row class="info-row">
        <el-col class="info-key" :span="2" :offset="0">
          车前视频数据:
        </el-col>
        <el-col :span="4">
          <wechat-recording/>
        </el-col>
        <el-col class="info-key" :span="2" :offset="0">
          车载设备数据：
        </el-col>
        <el-col :span="4">
          <car-recording/>
        </el-col>
      </el-row>
      <el-row class="step-row">
        <el-col :span="20" :offset="3" class="steps-container">
          <step>
            <template #number>1</template>
            <template #title>出车时刻</template>
            <template #time>{{ turout_time }}</template>
          </step>
          <step-line/>
          <step>
            <template #number>2</template>
            <template #title>抵达现场</template>
            <template #time>{{ arrived_time }}</template>
          </step>
          <step-line/>
          <step>
            <template #number>3</template>
            <template #title>患者上车</template>
            <template #time>{{ board_time }}</template>
          </step>
          <step-line/>
          <step>
            <template #number>4</template>
            <template #title>到达医院</template>
            <template #time>{{ done_time }}</template>
          </step>
        </el-col>
      </el-row>
      <el-row
        v-if="patient.zhiqingtongyishu"
        class="agree-pdf-line info-row"
      >
        <el-col class="info-key" :span="2">
          转院知情同意书:
        </el-col>
        <el-col
          :span="10"
          class="agree-pdf"
        >
          <a
            :href="baseUrl + patient.zhiqingtongyishu"
            download="转院知情同意书"
            target="_blank"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import CarRecording from "@components/patients/CarRecording";
import WechatRecording from "@components/patients/WechatRecording";
import Step from "@/components/patients/steps/Step";
import StepLine from "@/components/patients/steps/Line";
import { baseUrl } from "@/utils/base";
import { mapState } from "vuex";

export default {
  name: "AmbulanceStatus",
  components: {
    CarRecording,
    Step,
    StepLine,
    WechatRecording
  },
  data() {
    return {
      baseUrl: baseUrl,
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    carStage() {
      return this.patient.statu - 1;
    },
    ambulance() {
      return this.patient?.ambulance;
    },
    turout_time() {
      return this.getTime("turout_time");
    },
    arrived_time() {
      return this.getTime("arrived_time");
    },
    board_time() {
      return this.getTime("board_time");
    },
    done_time() {
      return this.getTime("done_time");
    }
  },
  mounted() {
    // 步骤条删除步骤编号
    const paras = document.querySelectorAll(".el-step__icon");
    for (let i = 0; i < paras.length; i++) {
      if (paras[i] != null) {
        paras[i].parentNode.removeChild(paras[i]);
      }
    }
  },
  methods: {
    getTime(key) {
      if (this.patient[key]) {
        return this.patient[key].split(" ")[1];
      } else {
        return "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.ambulance-info {
  padding-top: 12px;
}

.agree-pdf-line {
  font-size: 16px;
  color: #666666;

  a {
    text-decoration: none;
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: inline-block;
    background-size: cover; /* 调整背景图片的大小以覆盖整个元素 */
    background: url(../../assets/icons/recording/PDF.png) left center no-repeat;
  }
}

.step-row {
  padding-top: 50px;;
  padding-bottom: 40px;

  .steps-container {
    display: flex;
  }
}
</style>
